<template>
    <b-modal
        v-model="isVisible"
        title="인벤토리 생성"
        size="lg"
        centered
        hide-footer
        modal-class="calc-run-modal"
        header-class="calc-run-modal-header"
        body-class="calc-run-modal-body"
        @hidden="handleClose"
        @shown="handleShown"
    >
        <template #modal-header="{ close }">
            <div class="modal-header-content">
                <div class="modal-header-text">
                    <h4 class="modal-title">인벤토리 생성</h4>
                    <p class="modal-subtitle">배출량 계산 및 인벤토리를 생성합니다</p>
                </div>
                <button type="button" class="modal-close-btn" @click="close()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </template>

        <CalcRunForm
            :value="calcParams"
            :organizations="organizations"
            :selected-org-code="selectedOrgCode"
            :org-boundaries="orgBoundaries"
            :oper-boundaries="operBoundaries"
            :versions="versions"
            :loading="loading"
            @update:value="handleParamsChange"
            @select-org="handleOrgSelection"
            @submit="handleSubmit"
        />
    </b-modal>
</template>

<script>
import CalcRunForm from "./CalcRunForm.vue";

export default {
    components: {
        CalcRunForm,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        calcParams: {
            type: Object,
            required: true,
        },
        organizations: {
            type: Array,
            default: () => [],
        },
        selectedOrgCode: {
            type: String,
            default: null,
        },
        orgBoundaries: {
            type: Array,
            default: () => [],
        },
        operBoundaries: {
            type: Array,
            default: () => [],
        },
        versions: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit("update:visible", value);
            },
        },
    },
    methods: {
        handleParamsChange(newValue) {
            this.$emit("update:calcParams", newValue);
        },
        handleOrgSelection(orgCode) {
            this.$emit("select-org", orgCode);
        },
        handleSubmit(params) {
            this.$emit("submit", params);
        },
        handleClose() {
            this.$emit("close");
        },
        handleShown() {
            // 모달이 열릴 때 폼 초기화 이벤트 전달
            this.$emit("reset");
        },
    },
};
</script>

<style scoped>
/* Modal custom styling */
.calc-run-modal .modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.calc-run-modal-header {
    padding: 0;
    border-bottom: none;
    background: transparent;
}

.modal-header-content {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 9px 15px;
}

.modal-header-text {
    flex: 1;
}

.modal-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #2c2c2c;
    line-height: 1.3;
}

.modal-subtitle {
    margin: 4px 0 0;
    font-size: 13px;
    color: #999999;
    font-weight: 400;
}

.modal-close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: #999999;
    font-size: 16px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s ease;
    flex-shrink: 0;
    margin-left: 16px;
}

.modal-close-btn:hover {
    background: #f5f5f5;
    color: #2c2c2c;
}

.calc-run-modal-body {
    padding: 0;
    max-height: calc(85vh - 100px);
    overflow-y: auto;
    border-radius: 6px;
}
</style>
